import {Component, Host, h, Prop} from '@stencil/core';
import {nestIcons} from "../../resources/icons/icons";

@Component({
  tag: 'nest-icon',
  styleUrl: 'nest-icon.scss',
  shadow: true,
})
export class NestIcon {
  @Prop() name: string;

  render() {
    return (
      <Host>
        <div innerHTML={nestIcons[this.name]} />
      </Host>
    );
  }

}
